import { Component, EventEmitter, Input, Output } from "@angular/core";
import { crossBlackSVG } from "src/constants/svg/cross-black";
import moment from "moment";
import { UtilityService } from "src/services/utility.service";
import { ArtefactFilterOptions } from "src/pages/manage-grievances/constants";

@Component({
  selector: "app-admin-filter",
  templateUrl: "./admin-filter.component.html",
  styleUrls: ["./admin-filter.component.scss"],
})
export class AdminFilterComponent {
  @Input() reviewStatusOptions = [];
  @Output() onRemoveFilter = new EventEmitter();
  @Output() onFilterChange = new EventEmitter();
  @Input() appliedFilters?: ArtefactFilterOptions;

  selectedReviewStatus: string[] = [];

  crossBlackSVG = crossBlackSVG;

  constructor(private utilService: UtilityService) {}

  ngOnInit() {}

  onCheckboxChange(event: Event, orgType: string) {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.selectedReviewStatus.push(orgType);
    } else {
      this.selectedReviewStatus = this.selectedReviewStatus.filter(
        (item) => item !== orgType
      );
    }
    this.onFilterChange.emit({
      ...this.appliedFilters,
      selectedCheckboxes: this.selectedReviewStatus.filter((item) => item !== "All"),
    });
  }

  handleDateFormat() {
    this.appliedFilters = {
      ...this.appliedFilters,
      actionDate: {
        fromDate: this.formatDate(
          this.appliedFilters?.actionDate?.fromDate
        ) as string, // DD/MM/YYYY
        toDate: this.formatDate(
          this.appliedFilters?.actionDate?.toDate
        ) as string, // DD/MM/YYYY
      },
    };
  }

  formatDate = (date: string | moment.Moment | Date | undefined) => {
    if (!date) return undefined;
    return moment(date).format("YYYY-MM-DD");
  };

  onRemoveFilterClick(
    filterType:
      | "actionDate"
      | "category"
      | "dateFilterType"
      | "artifactType"
      | "userStatusType"
      | "visibility"
      | "isActive"
      | "organizationType"
      | "instanceTypes"
      | "usageCategory",
    value?: any
  ) {
    switch (filterType) {
      case "artifactType": {
        this.appliedFilters!.artifactType =
          this.appliedFilters?.artifactType?.filter(
            (type) => type.value !== value
          );
        break;
      }

      case "category": {
        this.appliedFilters!.category = (
          this.appliedFilters!.category ?? []
        ).filter((cat) => cat.value !== value);
        break;
      }

      case "actionDate":
      case "dateFilterType": {
        delete this.appliedFilters!.actionDate;
        delete this.appliedFilters!.dateFilterType;
        break;
      }

      case "userStatusType": {
        delete this.appliedFilters!.userStatusType;
        break;
      }

      case "visibility": {
        delete this.appliedFilters!.visibility;
        break;
      }

      case "isActive": {
        delete this.appliedFilters!.isActive;
        break;
      }

      case "organizationType": {
        this.appliedFilters!.organizationType = (
          this.appliedFilters!.organizationType ?? []
        ).filter((org) => org.value !== value);
        break;
      }

      case "instanceTypes": {
        delete this.appliedFilters!.instanceTypes;
        delete this.appliedFilters!.usageCategory;
        break;
      }

      case "usageCategory": {
        delete this.appliedFilters!.usageCategory;
        break;
      }

      default: {
        break;
      }
    }

    this.onRemoveFilter.emit(
      this.utilService.removeBlankFields<
        ArtefactFilterOptions,
        ArtefactFilterOptions
      >(this.appliedFilters || {})
    );
  }  
}
